import React, { useState } from "react";
import { Container, Row, Col, Modal } from "react-bootstrap";
import {
  MainLogoWhite,
  MenuIconLP,
  MenuIconCrossLP,
} from "../../../../app-constants";
import { Link } from "gatsby";
import BannerForm from "../../components/bannerfrom";

const HeaderLanding = () => {
  const [show, setShow] = useState(false);
  const [ulIsActive, setUlIsActive] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleDivClick = () => {
    setUlIsActive(!ulIsActive);
  };

  return (
    <>
      <section className="header_lp">
        <Container className="h-100">
          <Row className="h-100">
            <Col xs={6} md={6} className="my-auto">
              <div className="tek_lp_logo">
                <Link to="/" aria-label="Go to home page">
                  {MainLogoWhite}
                </Link>
              </div>
            </Col>
            <Col xs={6} md={6} className="my-auto">
              <div className="lp_mobile_view" onClick={handleDivClick}>
                {ulIsActive ? <>{MenuIconCrossLP}</> : <>{MenuIconLP}</>}
              </div>
              <ul className={`lp_main_menu ${ulIsActive ? "active" : ""}`}>
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/about">About</Link>
                </li>
                <li>
                  <Link to="/services">Services</Link>
                </li>
                <li>
                  <Link to="/solution">Solution</Link>
                </li>
                <li>
                  <Link to="/technologies">Technologies</Link>
                </li>
                <li>
                  <Link to="/location">Location</Link>
                </li>
                <li onClick={handleShow}>
                  <Link>Get A Proposal</Link>
                </li>
              </ul>
            </Col>
          </Row>
        </Container>
      </section>
      <Modal
        show={show}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="landing_lp_popup"
      >
        <div className="modal_forms">
          <BannerForm setShow={setShow} />
        </div>
      </Modal>
    </>
  );
};

export default HeaderLanding;
